/** A title widget's Display fields: fixed text or a report fact, heading size and alignment. */

import type { ReactNode } from 'react';

import { TITLE_SOURCES } from './report-facts.ts';
import type { WidgetDisplay } from './reports-api.ts';

export function TitleFields({
  display,
  setDisplay,
}: {
  display: WidgetDisplay;
  setDisplay: (patch: Partial<WidgetDisplay>) => void;
}): ReactNode {
  const source = display.title_source ?? 'text';
  return (
    <>
      <label className="rs-field">
        Title shows
        <select
          value={source}
          onChange={(event) => setDisplay({ title_source: event.target.value })}
        >
          {TITLE_SOURCES.map((item) => (
            <option key={item.key} value={item.key}>
              {item.label}
            </option>
          ))}
        </select>
      </label>
      {source === 'text' && (
        <label className="rs-field">
          Title
          <input
            value={display.title ?? ''}
            placeholder="Section name"
            maxLength={120}
            onChange={(event) => setDisplay({ title: event.target.value })}
          />
        </label>
      )}
      <label className="rs-field">
        Style
        <select
          value={display.heading ?? 'h3'}
          onChange={(event) => setDisplay({ heading: event.target.value as 'h1' | 'h2' | 'h3' })}
        >
          <option value="h1">Heading 1 (largest)</option>
          <option value="h2">Heading 2</option>
          <option value="h3">Heading 3 (section)</option>
        </select>
      </label>
      <label className="rs-field">
        Align
        <select
          value={display.align ?? 'left'}
          onChange={(event) =>
            setDisplay({ align: event.target.value as 'left' | 'center' | 'right' })
          }
        >
          <option value="left">Left</option>
          <option value="center">Centre</option>
          <option value="right">Right</option>
        </select>
      </label>
    </>
  );
}
